// extracted by mini-css-extract-plugin
export default {"total_revenue_wrapper":"BarGraph_total_revenue_wrapper__QcWrl","total_rev":"BarGraph_total_rev__oZxpl"};